/**
 * 注意事项：若存在多层组件嵌套、需要将click事件传给绑定的那一层
 * 如: components/CurrencyCard
 */
export { Track as default } from '@tiger/track';
